
(function () {
  'use strict';

  if (window.HnTopicPage && window.HnTopicPage.__v) return;
  var HP = { __v: 1 };

  function createLeadingDebounce(fn, wait) {
    var timer = null;
    return function () {
      var ctx = this;
      var args = arguments;
      var run = !timer;
      clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
      }, wait);
      if (run) return fn.apply(ctx, args);
    };
  }

  if (!window.HnLeadingDebounce) window.HnLeadingDebounce = createLeadingDebounce;

  HP.isApp = function () {
    return !!(
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.hanntoJsBridge
    ) || typeof hanntoJsBridge !== 'undefined';
  };

  /** Viewport wider than 744px: show download QR modal; otherwise open-app flow. */
  HP.isWideViewportForTopicQr = function () {
    return typeof window !== 'undefined' && window.innerWidth >= 744;
  };

  HP.shouldShowTopicQr = function () {
    return HP.isWideViewportForTopicQr() || (!isIos() && !isAndroid());
  };

  /** App only */
  HP.trackContentPageExpose = function (properties) {
    if (!HP.isApp()) return;
    var bridge = window.HanntoJsBridge;
    if (!bridge || typeof bridge.trackEvent !== 'function') return;
    var props = properties && typeof properties === 'object' ? properties : {};
    var ret = bridge.trackEvent({ event: 'WEB_PG_CONTENTPAGE_EVT_EXPOSE', properties: Object.assign({}, props, { source: 0 }) });
    if (ret && typeof ret.then === 'function') ret.then(function () {}).catch(function () {});
  };

  HP.buildLieneDownloadUrl = function (pageUrl, payload) {
    var href = pageUrl || window.location.href || '';
    var query =
      payload && typeof payload === 'object'
        ? buildDownloadQuery(payload, href)
        : buildDownloadQuery({}, href);
    return 'https://global.liene-life.com/lienephoto/download?' + query;
  };

  function locationOpen(url) {
    window.location.href = url;
  }

  function inRestrictedSocialInAppBrowser() {
    var s = navigator.userAgent || navigator.vendor || '';
    return (
      /twitter/i.test(s) ||
      /X-Twitter|XClient\/|com\.twitter\./i.test(s) ||
      /FBAN|FBAV|FB_IAB|\[FB/i.test(s) ||
      /instagram/i.test(s)
    );
  }

  function isIos() {
    var userAgent = navigator.userAgent || navigator.vendor || '';
    return (
      (/iPad|iPhone|iPod/i.test(userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
      !window.MSStream
    );
  }

  function isAndroid() {
    var userAgent = navigator.userAgent || '';
    var isAndroidUA = /android/i.test(userAgent);
    var isHarmonyOS = /harmonyos/i.test(userAgent) || /harmony/i.test(userAgent);
    var hasLinux = /linux/i.test(userAgent);
    var isMobile = /mobile/i.test(userAgent) || 'ontouchstart' in window;
    var isWindowsPhone = /windows phone/i.test(userAgent);
    return (isAndroidUA || isHarmonyOS || (hasLinux && isMobile)) && !isWindowsPhone;
  }

  function isAndroidWithLocationCallSupport() {
    var userAgent = (navigator.userAgent || '').toLowerCase();
    var chromeMatch = userAgent.match(/chrome\/(\d+)/);
    var chromeVersion = chromeMatch ? Number(chromeMatch[1]) : 0;
    return isAndroid() && (chromeVersion > 55 || userAgent.indexOf('samsungbrowser/') !== -1);
  }

  function iframeCall(url) {
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    iframe.setAttribute('style', 'display:none');
    document.body.appendChild(iframe);
    setTimeout(function () {
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    }, 200);
  }

  function buildDownloadQuery(p, webUrl) {
    var urlParams = new URLSearchParams(window.location.search);
    var payload = p && typeof p === 'object' ? p : {};
    var q = new URLSearchParams();
    if (payload.downloadType === 'deeplink') {
      var skip = { downloadType: 1, minAppVersion: 1, source: 1, pageUrl: 1, params: 1 };
      q.set('path', payload.path || '/flutter/deeplink');
      if (payload.scene) q.set('scene', payload.scene);
      if (payload.version) q.set('version', payload.version);
      Object.keys(payload).forEach(function (key) {
        if (skip[key] || key === 'path' || key === 'scene' || key === 'version') return;
        var val = payload[key];
        if (val == null || val === '' || typeof val === 'object') return;
        q.set(key, String(val));
      });
      return q.toString();
    }
    q.set('path', '/HtWebView');
    q.set('device', payload.device || '');
    var userId = localStorage.getItem('deviceId');
    if (userId) q.set('userId', userId);
    q.set('_ht_hideNav', true);
    q.set(
      'url',
      webUrl + (webUrl.indexOf('?') !== -1 ? '&' : '?') + 'userId=' + userId + '&_ht_hideNav=true' + (webUrl.indexOf('mothers') !== -1 ? '&serviceCode=0' : '')
    );
    var serviceCode = urlParams.get('serviceCode');
    if (serviceCode) q.set('serviceCode', serviceCode);
    q.set('ctx', JSON.stringify(payload));
    return q.toString();
  }

  HP.checkMinAppVersion = function (minAppVersion) {
    var minVer = minAppVersion != null ? parseInt(minAppVersion, 10) : 25000;
    var bridge = window.HanntoJsBridge;
    if (!bridge || typeof bridge.getSignature !== 'function') {
      return Promise.resolve(true);
    }
    return bridge.getSignature({ url: '/v1/c/user_center/feedback/presigned_url/', method: 'GET' })
      .then(function (res) {
        var data = res && res.data;
        var verHeader = data && data['PERMISSION-CLIENT-VERSION'];
        if (!verHeader) return true;
        var ver = parseInt(String(verHeader).replace(/\./g, ''), 10);
        if (!isNaN(ver) && ver < minVer) {
          if (window.HnShowToast) window.HnShowToast('Please update your app to the latest version');
          return false;
        }
        return true;
      })
      .catch(function () { return true; });
  };

  HP.openInApp = function (payload, pageUrlOverride) {
    var p = payload && typeof payload === 'object' ? payload : {};
    var minAppVersion = p.minAppVersion != null ? parseInt(p.minAppVersion, 10) : 25000;
    p.source = 0; // 0 站内引流，1 站外引流
    var webUrl =
      pageUrlOverride != null && pageUrlOverride !== ''
        ? pageUrlOverride
        : p.pageUrl != null && p.pageUrl !== ''
          ? p.pageUrl
          : window.location.href;
    if (HP.isApp()) {
      if (window.HanntoJsBridge) {
        var skipContentClick =
          !!p.skipContentClick ||
          !!(typeof document !== 'undefined' && document.querySelector('[data-topic-bts]'));
        if (!skipContentClick) {
          window.HanntoJsBridge.trackEvent({
            event: 'WEB_PG_CONTENTPAGE_EVT_CONTENTCLICK',
            properties: Object.assign({}, p)
          });
        }
        try {
          var navArgs = Object.assign({}, p);
          delete navArgs.minAppVersion;
          delete navArgs.skipContentClick;
          HP.checkMinAppVersion(minAppVersion).then(function (ok) {
            if (!ok) return;
            window.HanntoJsBridge.navigateToFlutter({ path: p.path, arguments: navArgs });
          });
        } catch (error) {
          console.log(error, 'error');
        }
      }
      return;
    }

    var currentUrl = HP.buildLieneDownloadUrl(webUrl, p);
    var query = currentUrl.split('?')[1] || '';
    var schemeUrl = 'hannto://global.liene-life.com/lienephoto/download/?' + query;

    if (isIos()) {
      setTimeout(function () {
        locationOpen(currentUrl);
      }, 0);
      return;
    }

    if (isAndroid()) {
      if (inRestrictedSocialInAppBrowser()) {
        window.location.href = "https://play.google.com/store/apps/details?id=com.hannto.fennel.overseas";
        return;
      }
      var settled = false;
      var hiddenKey = 'hidden';
      var visibilityEvent = 'visibilitychange';
      if (typeof document.msHidden !== 'undefined') {
        hiddenKey = 'msHidden';
        visibilityEvent = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        hiddenKey = 'webkitHidden';
        visibilityEvent = 'webkitvisibilitychange';
      }

      function cleanup() {
        document.removeEventListener(visibilityEvent, onVis);
        document.removeEventListener('baiduboxappvisibilitychange', onVis);
        clearTimeout(fallbackTimer);
      }

      function done(ok) {
        if (settled) return;
        settled = true;
        cleanup();
        if (!ok) locationOpen(currentUrl);
      }

      function onVis(ev) {
        var hidden =
          document[hiddenKey] || (ev && ev.hidden) || document.visibilityState === 'hidden';
        done(!!hidden);
      }

      document.addEventListener(visibilityEvent, onVis, false);
      document.addEventListener('baiduboxappvisibilitychange', onVis, false);

      var fallbackTimer = setTimeout(function () {
        var hidden = document[hiddenKey] || document.visibilityState === 'hidden';
        done(!!hidden);
      }, 2000);

      setTimeout(function () {
        if (isAndroidWithLocationCallSupport()) window.location.href = schemeUrl;
        else iframeCall(schemeUrl);
      }, 0);
      return;
    }

    locationOpen(currentUrl);
  };

  HP.openInAppDebounced = window.HnLeadingDebounce
    ? window.HnLeadingDebounce(function (payload, pageUrlOverride) {
        HP.openInApp(payload, pageUrlOverride);
      }, 1200)
    : function (payload, pageUrlOverride) {
        HP.openInApp(payload, pageUrlOverride);
      };

  HP.initQrModal = function (cfg) {
    HP.showTopicDownloadQr = function () {};
    var modal = document.getElementById(cfg.modalId);
    var closeBtn = cfg.closeId ? document.getElementById(cfg.closeId) : null;
    var qrWrap = document.getElementById(cfg.qrId);
    if (!modal || !qrWrap) return;

    function showQrForUrl(downloadUrl) {
      if (!window.QRCode) return;
      QRCode.toDataURL(
        downloadUrl,
        { width: cfg.qrWidth || 180, margin: 0 },
        function (err, dataUrl) {
          if (err) return;
          var img = document.createElement('img');
          img.src = dataUrl;
          qrWrap.innerHTML = '';
          qrWrap.appendChild(img);
        }
      );
      modal.classList.add(cfg.visibleClass || 'topic-modal--visible');
    }

    HP.showTopicDownloadQr = function (pageUrl, payload) {
      showQrForUrl(HP.buildLieneDownloadUrl(pageUrl, payload));
    };

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.classList.remove(cfg.visibleClass || 'topic-modal--visible');
      });
    }
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.classList.remove(cfg.visibleClass || 'topic-modal--visible');
    });

    return { showQrForUrl: showQrForUrl };
  };

  HP.showNetworkError = function (networkRootSelector) {
    var root = networkRootSelector ? document.querySelector(networkRootSelector) : document;
    if (!root) return;
    var el = root.querySelector('.hn-network-error');
    var wrap = root.querySelector('[data-topic-network-hide]');
    if (el) {
      el.classList.add('hn-network-error--visible');
      el.setAttribute('aria-hidden', 'false');
    }
    if (wrap) wrap.style.display = 'none';
  };

  HP.onTopicHit = function (params, pageUrl, networkRootSelector) {
    var p = params && typeof params === 'object' ? params : {};
    var resolvedPageUrl =
      pageUrl != null && pageUrl !== '' ? pageUrl : p.pageUrl != null && p.pageUrl !== '' ? p.pageUrl : null;
    var resolvedNetwork =
      networkRootSelector != null && networkRootSelector !== ''
        ? networkRootSelector
        : p.networkRootSelector != null && p.networkRootSelector !== ''
          ? p.networkRootSelector
          : p.wrapSelector != null && p.wrapSelector !== ''
            ? p.wrapSelector
            : null;

    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      HP.showNetworkError(resolvedNetwork);
      return;
    }
    if (HP.shouldShowTopicQr()) {
      if (HP.showTopicDownloadQr) HP.showTopicDownloadQr(resolvedPageUrl, p);
    } else HP.openInAppDebounced(p, resolvedPageUrl);
  };

  window.HnTopicPage = HP;
})();
